function renderWarrantyModal() {
    const modal = document.createElement('div');
    let modalBackdrop = document.querySelector('.gz-modal-backdrop');
    modal.classList.add('gz-warranty-modal');

    if (modalBackdrop === null) {
        modalBackdrop = document.createElement('div').classList.add('gz-modal-backdrop');
        document.body.appendChild(modalBackdrop);
    }

    const modalContent = `
    <div class="gz-modal-content">
        <div class="gz-warranty-modal-header">
            <h2 id="gz-modal-title">1 Year Warranty</h2>
        </div>
            <button class="gz-warranty-modal-close close" aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.1719 2.42188L9.54688 8L15.125 13.5781L15.9219 14.375L14.375 15.9688L13.5781 15.1719L8 9.59375L2.42188 15.1719L1.625 15.9688L0.03125 14.375L0.828125 13.5781L6.40625 8L0.828125 2.42188L0.03125 1.625L1.625 0.03125L2.42188 0.828125L8 6.45312L13.5781 0.875L14.375 0.078125L15.9688 1.625L15.1719 2.42188Z" fill="#193154"/>
            </svg>
            </button>
        <div id="gz-warranty-modal-img-container">
            <img id="gz-warranty-modal-warrantylife" src="https://cdn.shopify.com/s/files/1/0011/1411/2060/files/warrantylife.png?v=1723650676" alt="WarrantyLife" />
        </div>
        <div class="gz-modal-main-content gz-warranty-modal-main-content">
            <p id="gz-warranty-modal-terms">Gazelle has partnered with <b>WarrantyLife</b> to provide a 1 year warranty for all devices purchased from Gazelle. <span>See <a href="https://www.warrantylife.com/membership-terms">terms and conditions.</a></span></p>
            <p>This warranty covers all mechanical breakdowns:</p>
            <div>
                <img src="https://cdn.shopify.com/s/files/1/0011/1411/2060/files/wrench-screwdriver.png?v=1723753520" alt="" />
                <span>Any issues with internal components</span>
            </div>
            <div>
                <img style="margin-right: 23px;" src="https://cdn.shopify.com/s/files/1/0011/1411/2060/files/zap.png?v=1723753519" alt="" />
                <span>Issues with power</span>
            </div>
            <div>
                <img src="https://cdn.shopify.com/s/files/1/0011/1411/2060/files/battery.png?v=1723753520" alt="" />
                <span>Malfunctions with the battery</span>
            </div>
            <div>
                <img src="https://cdn.shopify.com/s/files/1/0011/1411/2060/files/rabbit.png?v=1723753520" alt="" />
                <span>Most claims are processed in 1-2 business days.</span>
            </div>
        </div>
    </div>
    `;

    modal.innerHTML = modalContent;

    document.body.appendChild(modal)

    const closeButton = modal.querySelector('.close');
    closeButton.addEventListener('click', () => closeModal());
    modalBackdrop.addEventListener('click', () => closeModal());

    const warrantyButton = document.querySelectorAll('.gz-warranty-modal-link');

    if (warrantyButton.length !== 0) {
        warrantyButton.forEach((btn) => {
            btn.addEventListener('click', () => openModal());
            btn.addEventListener('keydown', () => openModal());
        })
    }

    function openModal() {
        document.body.style.overflow = 'hidden';
        modalBackdrop.classList.add('show');
        modal.classList.add('show');
    }

    function closeModal() {
        document.body.style.overflow = '';
        modalBackdrop.classList.remove('show');
        modal.classList.remove('show');
    }
}

renderWarrantyModal();